import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { AuthorizationService } from '../../shared/services/authorization.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationCanActivateGuard implements CanActivate {
  constructor(
    private _authorize: AuthorizationService,
    private _router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._authorize.isAuthenticated().then((result: boolean) => {
      if (!result) {
        if (!state.url.includes('mfa')) {
          sessionStorage.setItem('RequestedURL', state.url);
        }
        this._router.navigateByUrl('login');
      }

      return result;
    });
  }
}
